/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M22.2686 14.6922a.9146.9146 0 0 1-.6853.3078h-6.6666l-.1348.0121a.7502.7502 0 0 0 .1333 1.4879c-.0005 0 .0005 0 0 0h6.6681l.22-.0099a2.4052 2.4052 0 0 0 1.297-.5254c.4606-.3719.7819-.9095.8732-1.5221A2.434 2.434 0 0 0 24 14.0833V2.4167l-.0099-.22a2.4054 2.4054 0 0 0-.5254-1.297A2.4145 2.4145 0 0 0 21.5833 0H9.9167l-.22.0099a2.4053 2.4053 0 0 0-1.297.5254A2.4142 2.4142 0 0 0 7.5 2.4167v6.6666l.012.1349A.75.75 0 0 0 9 9.0847c0 .0005 0-.0005 0 0V2.4167l.012-.1484a.9145.9145 0 0 1 .2194-.4605.9147.9147 0 0 1 .6853-.3078h11.6666l.1484.012a.9148.9148 0 0 1 .4605.2194.9147.9147 0 0 1 .3078.6853v11.6666l-.012.1484a.9141.9141 0 0 1-.2194.4605ZM18 9.75l.0121.1348A.7502.7502 0 0 0 19.5 9.7514c0-.0004 0 .0005 0 0V4.5h-5.25l-.1348.012a.7502.7502 0 0 0-.6152.738l.0121.1348A.7502.7502 0 0 0 14.2485 6c.0005 0-.0004 0 0 0l2.6907-.0015L4.7197 18.2197l-.0868.1038a.7502.7502 0 0 0 1.1464.9579c.0004-.0004-.0003.0003 0 0l.001-.0011L17.9986 7.0605 18 9.75Zm-18 9c0-2.8995 2.3505-5.25 5.25-5.25a.75.75 0 0 1 0 1.5c-2.071 0-3.75 1.6789-3.75 3.75s1.679 3.75 3.75 3.75C7.321 22.5 9 20.8211 9 18.75a.75.75 0 0 1 1.5 0c0 2.8995-2.3505 5.25-5.25 5.25S0 21.6495 0 18.75Z"
    clipRule="evenodd"
  />,
  'Expression'
);
